/* eslint-disable import/first */
import React from 'react';

export default function Home(props) {
  return (
    <svg width="32" height="30" viewBox="0 0 32 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4 0H28C30.21 0 32 1.85172 32 4.13793V13.4379C32 14.9183 31.234 16.2869 29.992 17.0255L15.652 25.5476L1.942 17.0379C0.737 16.29 0 14.9431 0 13.4897V4.13793C0 1.85172 1.79 0 4 0Z"
        fill="#F1F9FF"
      />
      <path
        d="M25.449 19.5086L26.277 18.5672L23.792 16.1341V11.2079H20.1V12.6624L15.64 8.2793L8.14 15.5165L7.714 15.9169L7.484 16.1341L5 18.5662L5.828 19.5076L7.485 17.8555V28.7165H6.254V29.989H25.024V28.7165H23.792V17.8545L25.449 19.5076V19.5086ZM21.33 12.4814H22.56V15.1834L21.33 13.9379V12.4814ZM14.408 28.7165V26.4086H16.869V28.7155H14.408V28.7165ZM16.869 25.1352H14.408V22.191H16.869V25.1352ZM18.1 28.7165V20.9165H13.177V28.7155H8.715V16.6979L15.639 9.99964L21.1 15.4172L22.562 17.0445V28.7155H18.1V28.7165Z"
        fill="black"
      />
      <path d="M13.1768 18.3711H18.0998V19.6435H13.1768V18.3711Z" fill="#FF151B" />
    </svg>
  );
}
